import React from 'react';
import EmailPreferences from '../components/EmailPreferences';

const JobSeekerTabEmailPrefs = () => <EmailPreferences showJobAlerts />;

export default JobSeekerTabEmailPrefs;
